import React from "react";
import { Alert, Box, Divider, Typography } from "@mui/material";

const preStyle = {
  margin: 0,
  fontSize: "0.75rem",
  overflowX: "auto",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  fontFamily: "Menlo, Monaco, Consolas, 'Courier New', monospace",
};

const GatewayRequestDebugPanel = ({ title, request }) => {
  if (process.env.NODE_ENV !== "development" || !request) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Box sx={{ mb: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 700, display: "block" }}>
          Request URL
        </Typography>
        <pre style={preStyle}>{`${request.method || "POST"} ${request.url || ""}`}</pre>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box>
        <Typography variant="caption" sx={{ fontWeight: 700, display: "block" }}>
          Request Payload
        </Typography>
        <pre style={preStyle}>{JSON.stringify(request.payload || {}, null, 2)}</pre>
      </Box>
      {request.blockedReason ? (
        <Typography variant="caption" color="warning.main" sx={{ display: "block", mt: 1 }}>
          {request.blockedReason}
        </Typography>
      ) : null}
    </Alert>
  );
};

export default GatewayRequestDebugPanel;
